export default __webpack_public_path__ + "static/media/disconnectShopify1.046f6958.svg";